import React from 'react'
import './Home.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Introduction from '../../Pages/Introduction';
const Home = ({ onLogout }) => {
  return (
     <div className='home-outer-cont'>
      <Header onLogout={onLogout}/>
      <main>
      <Introduction/>
      </main>
     <Footer/>
     </div>
  )
}
export default Home
